import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { FiEdit2 } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import { ToastContainer } from "react-toastify";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import { Insurances } from "../../utils/DataSource";
import { getBeneficiries } from "../../store/actions/BenActions";
import {
  getBenInsurances,
  addBenInsurance,
  updateBenInsurance,
  deleteBenInsurance,
} from "../../store/actions/BenInsuranceActions";
import {
  addnewInsurance,
  deleteInsurance,
  getInsurances,
  updateInsurance,
} from "../../store/actions/InsuranceActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ContentLoader from "react-content-loader";
import changeMonthToText from "../../utils/ChangeMonthToText";
import DownloadBtn from "../../components/DownloadBtn";
import { currentDate } from "../../utils/currentDate";
import changeFromTimeStamp from "../../utils/ChangeMonthToText";

function Insurance() {
  const dispatch = useDispatch();
  // insurance declaration
  const [insurance, setInsurance] = useState({
    id: "",
    name: "",
    description: "",
  });

  // ben insurance declaration
  const [benInsurance, setBenInsurance] = useState({
    id: "",
    beneficiaryId: "",
    insuranceCategoryId: "",
    endDate: "",
    startDate: "",
  });

  // call insurances
  const insurances = useSelector((state) => state.insurances);
  const beneficiaries = useSelector((state) => state.beneficiries);
  const benInsurances = useSelector((state) => state.benInsurances);
  const loaders = useSelector((state) => state.loadersState);

  const [openTab, setOpenTab] = useState(1);

  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    clearOverlayInput();
  }

  function clearOverlayInput() {
    dispatch({
      type: "SET_BEN_INSURANCE_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_INSURANCE_MESSAGE",
      message: "",
    });

    setBenInsurance({
      id: "",
      beneficiaryId: "",
      insuranceCategoryId: "",
      endDate: "",
      startDate: "",
    });

    setInsurance({
      id: "",
      name: "",
      description: "",
    });
  }
  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedBenInsurance) {
    setEditBeneOverlay(!editBenOverlay);
    setBenInsurance({
      id: passedBenInsurance.id,
      beneficiaryId: passedBenInsurance.beneficiaryId,
      insuranceCategoryId: passedBenInsurance.insuranceId,
      endDate: passedBenInsurance.end,
      startDate: passedBenInsurance.start,
    });
  }
  const [addInsurance, setAddInsurance] = useState(0);
  function addInsuranceController() {
    setAddInsurance(!addInsurance);
  }

  const [editInsurance, setEditInsurance] = useState(0);
  function editInsuranceController(passedInsurance) {
    setEditInsurance(!editInsurance);
    setInsurance({
      id: passedInsurance.id,
      name: passedInsurance.name,
    });
  }

  const [filterInsuranceCardOverlay, setFilterInsuranceCardOverlay] =
    useState(0);
  function fundFilterOverlayController() {
    setFilterInsuranceCardOverlay(!filterInsuranceCardOverlay);
  }

  // Insurance dropdowns
  const [InsuranceDropdown, setInsuranceDropDown] = useState(0);

  // for insurance table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "Start Date",
        accessor: "startDate",
      },
      {
        Header: "End Date",
        accessor: "endDate",
      },

      {
        Header: "Insurance",
        accessor: "insurance",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform  mituelle fund data
  let [loadedBeneficiaryInsurances, setLoadedBenInsurances] = useState([]);

  useEffect(() => {
    setLoadedBenInsurances([]);
    for (let i = 0; i < benInsurances.length; i++) {
      const benInsurance = {
        count: i + 1,
        id: benInsurances[i].id,
        beneficiary: `${benInsurances[i].beneficiary.firstName}  
      ${benInsurances[i].beneficiary.lastName}`,
        beneficiaryId: benInsurances[i].beneficiary.id,
        insurance: benInsurances[i].insuranceCategories.name,
        insuranceId: benInsurances[i].insuranceCategories.id,
        startDate: changeMonthToText(benInsurances[i].startDate),
        endDate: changeMonthToText(benInsurances[i].endDate),
        start: benInsurances[i].startDate,
        end: benInsurances[i].endDate,
        action: (
          <Action
            deleteAction={() => {
              handleDeleteBenInsurance(benInsurances[i].id);
            }}
            editAction={() => editOverlayController(benInsurance)}
          />
        ),
      };
      setLoadedBenInsurances((loadedBeneficiaryInsurances) => [
        ...loadedBeneficiaryInsurances,
        benInsurance,
      ]);

      if (
        loaders.benInsurance.deletingAction &&
        loaders.benInsurance.deletingAction.deleting
      ) {
        const currentBenInsurances = loadedBeneficiaryInsurances;
        const newData = currentBenInsurances.map((benInsurance) =>
          benInsurance.id === loaders.benInsurance.deletingAction.id
            ? {
              ...benInsurance,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : benInsurance
        );
        setLoadedBenInsurances(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benInsurances, loaders.benInsurance.deletingAction]);

  let [loadingBenInsurances, setLoadingBenInsurances] = useState([]);

  useEffect(() => {
    setLoadingBenInsurances([]);
    for (let i = 0; i < 5; i++) {
      const benInsurance = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        insurance: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),

        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingBenInsurances((loadingBenInsurances) => [
        ...loadingBenInsurances,
        benInsurance,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benInsurance.fetchingLoaders]);

  // reload insurances
  useEffect(() => {
    dispatch(getInsurances());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reload beneficiries insurances
  useEffect(() => {
    dispatch(getBenInsurances());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // years select option
  const insuranceOptions = [];
  for (let i = 0; i < insurances.length; i++) {
    const insurance = {
      value: insurances[i].id,
      label: insurances[i].name,
    };

    insuranceOptions.push(insurance);
  }
  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }
  // selected beneficiary
  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === benInsurance.beneficiaryId
  );
  // handleBenInsuranceSubmit
  const handleBenInsuranceSubmit = (e) => {
    e.preventDefault();
    if (benInsurance.id) {
      const id = benInsurance.id;
      const updatedBenInsurance = {
        beneficiaryId: benInsurance.beneficiaryId,
        insuranceCategoryId: benInsurance.insuranceCategoryId,
        endDate: benInsurance.endDate,
        startDate: benInsurance.startDate,
      };
      dispatch(
        updateBenInsurance(
          updatedBenInsurance,
          id,
          closeBenInsuranceAfterUpdating
        )
      );
    } else {
      dispatch(addBenInsurance(benInsurance, closeBenInsuranceFormAfterAdding));
    }
  };
  // handle insurance submit
  const handleInsuranceSubmit = (e) => {
    e.preventDefault();
    if (insurance.id) {
      const id = insurance.id;
      const updatedInsurance = {
        name: insurance.name,
        description: insurance.description,
      };
      dispatch(
        updateInsurance(updatedInsurance, id, closeInsuranceAfterUpdating)
      );
    } else {
      dispatch(addnewInsurance(insurance, closeInsuranceFormAfterAdding));
    }
  };

  // handle insurance delete
  const handleInsuranceDelete = (id) => {
    dispatch(deleteInsurance(id));
  };
  // handle beneficiary insurance delete
  const handleDeleteBenInsurance = (id) => {
    dispatch(deleteBenInsurance(id));
  };

  // closing insurance after cu
  function closeInsuranceFormAfterAdding() {
    addInsuranceController();
    setInsurance({
      id: "",
      name: "",
      description: "",
    });
  }

  function closeInsuranceAfterUpdating() {
    editInsuranceController({
      id: "",
      name: "",
      description: "",
    });
  }
  // closing ben insurance after cu
  function closeBenInsuranceFormAfterAdding() {
    benOverlayController();
    setBenInsurance({
      id: "",
      beneficiaryId: "",
      insuranceCategoryId: "",
      endDate: "",
      startDate: "",
    });
  }

  function closeBenInsuranceAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      insuranceCategoryId: "",
      endDate: "",
      startDate: "",
    });
  }

  function clearErrors() {
    dispatch({
      type: "SET_BEN_INSURANCE_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_INSURANCE_MESSAGE",
      message: "",
    });
  }
  return (
    <DashLayout>
      <div className="bg-white mx-10">
        <div className="text-xs">
          <ToastContainer />
        </div>
        <div className="flex flex-col md:flex-row p-10 pt-5  pl-10 pb-0">
          <h2 className="font-semibold">Insurance information</h2>
          <div className="mt-2 md:m-auto ml-0 md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              onClick={() => {
                benOverlayController();
              }}
              message="Register"
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              onClick={() => {
                fundFilterOverlayController();
              }}
              message="Filter"
            >
              <FiFilter />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              onClick={() => {
                dispatch(getBenInsurances());
              }}
              message="Refresh"
            >
              <FcRefresh
                className={
                  loaders.insurance.fetchingLoaders ? " refresh-loader" : " "
                }
              />
            </button>

            <DownloadBtn filename={`insurances-${changeFromTimeStamp(currentDate())}`} table="table-to-xls" />
          </div>
        </div>
        {/* insurance tabs */}
        <div className="flex flex-wrap">
          <div className="w-full">
            <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
              <div>
                <div className="tab-content tab-space">
                  <div className={"flex flex-col mt-5"} id="link1">
                    <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
                      {/* insurance table */}
                      <div className="w-full ">
                        {(!loaders.benInsurance.fetchingLoaders &&
                          benInsurances.length < 1) |
                          loaders.benInsurance.fetchFailedMessage ? (
                          <div
                            className={
                              !loaders.benInsurance.fetchFailedMessage
                                ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                            }
                          >
                            <p>
                              {!loaders.benInsurance.fetchFailedMessage
                                ? "No insurance record found"
                                : loaders.benInsurance.fetchFailedMessage}
                            </p>
                          </div>
                        ) : (
                          <Table
                            data={
                              loaders.benInsurance.fetchingLoaders
                                ? loadingBenInsurances
                                : loadedBeneficiaryInsurances
                            }
                            columns={columns}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end.... */}
        {/*add insurance overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.benInsurance.message && openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benInsurance.message}</p>
              </div>
              <div
                className={
                  loaders.insurance.message && openTab === 2
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.insurance.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Register beneficiary insurance"
                      : "Change beneficiary insurance info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                            beneficiaryId: "",
                            insuranceCategoryId: "",
                            endDate: "",
                            startDate: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex mb-0 list-none flex-wrap  font-medium  flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? " text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : " text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Beneficiary
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i>{" "}
                          Insurance
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleBenInsuranceSubmit}
                            >
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Beneficiary Id</label>
                                <Select
                                  options={beneficiriesOption}
                                  value={beneficiriesOption.find(
                                    (obj) =>
                                      obj.value === benInsurance.beneficiaryId
                                  )}
                                  onChange={(e) =>
                                    setBenInsurance({
                                      ...benInsurance,
                                      beneficiaryId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Name </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input + "uppercase"}
                                    value={
                                      benInsurance.beneficiaryId
                                        ? selectedBeneficiary[0].name
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <div className="flex w-full">
                                  <div className="flex flex-col">
                                    <label>Start date </label>
                                    <div
                                      className={
                                        style.field.parentDiv + " mr-2 w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benInsurance.startDate}
                                        onChange={(e) =>
                                          setBenInsurance({
                                            ...benInsurance,
                                            startDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col ml-2">
                                    <label>End date </label>

                                    <div
                                      className={
                                        style.field.parentDiv + " w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benInsurance.endDate}
                                        onChange={(e) =>
                                          setBenInsurance({
                                            ...benInsurance,
                                            endDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <label>Insurance </label>
                                <Select
                                  options={insuranceOptions}
                                  value={insuranceOptions.find(
                                    (obj) =>
                                      obj.value ===
                                      benInsurance.insuranceCategoryId
                                  )}
                                  onChange={(e) =>
                                    setBenInsurance({
                                      ...benInsurance,
                                      insuranceCategoryId: e.value,
                                    })
                                  }
                                />
                              </div>

                              {/* save btn */}
                              <button
                                type="submit"
                                className={style.loginBtn}
                                disabled={loaders.benInsurance.sendingLoader}
                              >
                                {!loaders.benInsurance.sendingLoader ? (
                                  <p className="m-auto">
                                    {addBenOverlay ? "Save" : "Update"}
                                  </p>
                                ) : (
                                  <div className="spinner m-auto">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                )}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addInsurance & !editInsurance
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addInsuranceController();
                                }}
                              >
                                {"New insurance"}
                              </button>
                              <div
                                className={
                                  !addInsurance & !editInsurance
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.insurance.fetchingLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  insurances.map((insurance, i) => {
                                    return loaders.insurance.deletingAction &&
                                      loaders.insurance.deletingAction.id ===
                                      insurance.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "border border-gray-300 p-3 mb-3 rounded bg-gray-100 flex"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setInsuranceDropDown(i);
                                        }}
                                      >
                                        <div className="flex mb-2 m-auto ml-0 text-start cursor-pointer">
                                          <h2 className="font-semibold m-auto ml-0">
                                            {insurance.name}
                                          </h2>
                                        </div>
                                        <div
                                          className={
                                            InsuranceDropdown === i
                                              ? "flex flex-col"
                                              : "hidden"
                                          }
                                        >
                                          <div className="flex m-auto fit-content">
                                            <button
                                              className="flex p-1 rounded border border-gray-300 hover:border-gray-300 bg-gray-300 text-gray-500 mr-2"
                                              onClick={() => {
                                                editInsuranceController(
                                                  insurance
                                                );
                                              }}
                                            >
                                              <FiEdit2
                                                onClick={() => {
                                                  editInsuranceController(
                                                    insurance
                                                  );
                                                }}
                                              />
                                            </button>
                                            <button className="flex p-1 rounded border border-red-300 hover:border-red-300 bg-red-300 text-red-500 mr-2">
                                              <AiOutlineDelete
                                                onClick={() => {
                                                  handleInsuranceDelete(
                                                    insurance.id
                                                  );
                                                }}
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add Insurance */}
                              <div
                                className={
                                  addInsurance || editInsurance
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                              >
                                <h2 className="font-semibold">
                                  {addInsurance
                                    ? "Register insurance"
                                    : "Change insurance info"}
                                </h2>
                                {/*  field */}
                                <form
                                  className="py-2 w-full"
                                  onSubmit={handleInsuranceSubmit}
                                >
                                  <label>Insurance name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={insurance.name}
                                      onChange={(e) =>
                                        setInsurance({
                                          ...insurance,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <button
                                    type="submit"
                                    className={style.loginBtn}
                                    disabled={loaders.insurance.sendingLoader}
                                  >
                                    {!loaders.insurance.sendingLoader ? (
                                      <p className="m-auto">
                                        {addInsurance ? "Save" : "Update"}
                                      </p>
                                    ) : (
                                      <div className="spinner m-auto">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    )}
                                  </button>
                                </form>
                                <p
                                  className={
                                    addInsurance | editInsurance
                                      ? "p-3 pl-0 flex rounded text-indigo-500 font-normal mb-3 cursor-pointer"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addInsurance
                                      ? addInsuranceController()
                                      : editInsuranceController();
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>

        {/* filter insurance  overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold">{"Filter insurance"}</h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col pt-3">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range</label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>{" "}
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Insurances </label>
                  <Select options={Insurances} isMulti />
                </div>

                {/*  field */}
                <div className="py-2 w-full">
                  <label>Startdate range </label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Guhera"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Kugeza"
                      />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Enddate range </label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Guhera"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Kugeza"
                      />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Needed Amount </label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="2000"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="4000"
                      />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>InsuranceCard range </label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="2000"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="4000"
                      />
                    </div>
                  </div>
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">{"Apply"}</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Start date</th>
            <th>End date</th>
            <th>Insurance</th>
          </tr>
        </thead>

        <tbody>
          {benInsurances.map((beninsurance) =>
            <tr>
              <td>{beninsurance.beneficiary.firstName}
                {beninsurance.beneficiary.lastName}</td>
              <td>{changeMonthToText(beninsurance.startDate)}</td>
              <td>{changeMonthToText(beninsurance.endDate)}</td>
              <td>{beninsurance.insuranceCategories.name}</td>
            </tr>
          )}
        </tbody>
      </table>
    </DashLayout>
  );
}

export default Insurance;
